import cn from 'classnames';
import { Badge, Typography } from 'seagull';
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
import styles from "./CopyLinkForProposalModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getRecipientBadgeInfo(_ref) {
  let {
    isSignatureRequired,
    hasSigned,
    isPrimary
  } = _ref;
  if (!isSignatureRequired) return null;
  if (hasSigned) return {
    text: 'Signed',
    skin: 'success',
    badgeSkin: 'success'
  };
  // even if primary contact - if signed return signed
  else if (isPrimary) return {
    text: 'Primary contact',
    skin: 'disabled'
  };
  // if primary contact and not signed return primary contact
  else return {
    text: 'Required to sign',
    skin: 'disabled'
  };
}
function RecipientBadge(props) {
  const badgeInfo = getRecipientBadgeInfo(props);
  return badgeInfo && /*#__PURE__*/_jsx(Badge, {
    rounded: true,
    outlined: true,
    "data-testid": props.testid,
    skin: badgeInfo.badgeSkin,
    children: /*#__PURE__*/_jsx(Typography, {
      skin: badgeInfo.skin,
      variant: "paragraph2",
      children: badgeInfo.text
    })
  });
}
export function CopyLinkForProposalModal(props) {
  const {
    className,
    onClick,
    onError,
    onCopy,
    recipients,
    info
  } = props;
  const dataTestId = props['data-testid'] || 'copy-to-clipboard';
  const Recipient = _ref2 => {
    let {
      recipient,
      isPrimary = false
    } = _ref2;
    const {
      email,
      isSignatureRequired,
      hasSigned,
      notificationURL
    } = recipient;
    return /*#__PURE__*/_jsxs("div", {
      className: styles.linkRow,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.reviewerDetails,
        children: [/*#__PURE__*/_jsx(Typography, {
          ellipsis: true,
          variant: 'paragraph1',
          weight: 'normal',
          "data-testid": 'recipient-name',
          children: recipient.fullName()
        }), /*#__PURE__*/_jsx(Typography, {
          ellipsis: true,
          variant: 'paragraph2',
          weight: 'light',
          "data-testid": 'recipient-email',
          children: email
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.badge,
        children: /*#__PURE__*/_jsx(RecipientBadge, {
          isSignatureRequired: isSignatureRequired,
          hasSigned: hasSigned,
          isPrimary: isPrimary,
          testid: "recipient-badge-".concat(email)
        })
      }), /*#__PURE__*/_jsx(CopyToClipboard, {
        value: notificationURL,
        buttonLabel: 'Copy',
        onClick: onClick,
        onError: onError,
        onCopy: onCopy,
        buttonClassname: styles.button,
        textfieldClassname: styles.link,
        className: styles.linkWrapper
      })]
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.multipleRecipientsRoot, className),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx(Typography, {
      className: styles.title,
      children: "Links are unique per recipient. Make sure that each link is sent to the intended recipient."
    }), info, /*#__PURE__*/_jsxs("div", {
      className: styles.linksContainer,
      children: [/*#__PURE__*/_jsx(Recipient, {
        recipient: recipients.primary,
        isPrimary: true
      }, recipients.primary.email), recipients.additionalRecipients.length > 0 && /*#__PURE__*/_jsx(Typography, {
        className: styles.additionalRecipientsTitle,
        children: "Additional recipients:"
      }), recipients.additionalRecipients.map(recipient => /*#__PURE__*/_jsx(Recipient, {
        recipient: recipient
      }, recipient.email))]
    })]
  });
}